exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.m-sm-0[data-v-98a7c7a6]{margin-left:0px;margin-right:0px}.container[data-v-98a7c7a6]{padding:0}}\n", ""]);

// exports
